import axios from "axios"
import { environment } from "../../../environments/environment"

export const getOrdersList = (page, pageSize, search, order, body) => {
    let params = new URLSearchParams()
    params.append("page", page)
    params.append("pageSize", pageSize)
    params.append("search", search)
    params.append("orderBy", order)

    return axios.post(environment.getOrdersList + params, body)
}

export const getOrdersListParts = (page, pageSize, search, order, body) => {
    let params = new URLSearchParams()
    params.append("page", page)
    params.append("pageSize", pageSize)
    params.append("search", search)
    params.append("orderBy", order)

    return axios.post(environment.getOrdersListDetails + params, body)
}

export const getGeneralTimeLine = (page = 0, pageSize = 200, search = "", order = "id", body = []) => {
    let params = new URLSearchParams()
    params.append("page", page)
    params.append("pageSize", pageSize)
    params.append("search", search)
    params.append("orderBy", order)

    return axios.post(environment.getOrderGeneralTimeLineData + params, body)
}

export const getOrderGeneralInformation = (orderId) => {
    let param = new URLSearchParams()
    param.append("orderId", orderId)

    return axios.get(environment.getOrderGeneralInformation + param)
}

export const getOrderDetailsInfo = (lineNumber, orderId) => {
    let param = new URLSearchParams()
    param.append("lineNumber", lineNumber)
    param.append("orderId", orderId)

    return axios.get(environment.getOrderDetailInformation + param)
}

export const updateOrdersGeneralInformation = (body) => {
    return axios.put(environment.updateOrdersGeneralInfo, body)
}

export const updateOrderDetailsParts = (body) => {
    return axios.put(environment.updateOrderDetails, body)
}

export const authorizeOrder = (body) => {
    return axios.put(environment.authorizeOrder, body)
}
export const getApprovalPriceRanges = () => {
    return axios.get(environment.getApprovalRange)
}

export const sentToVendorOrder = (body) => { 
    return axios.put(environment.sentOrderToVendor , body)
}


export const createDiscrepancy = (body) =>{
    return axios.post(environment.saveDiscrepancy , body)
}